exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".align-logo-center {\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/kiosklogin/Template/KioskLogin.css
// module id = 531
// module chunks = 3